import React from "react";
import propTypes from "prop-types";
import Icon from "../icons/Icon";
import classnames from "classnames";

import "./NavCard.scss";
import { createDataAttributes } from "../../utilities";

const NavCard = ({
  disabled,
  onClick,
  icon,
  title,
  link,
  target,
  className,
  dataAttrib
}) => {
  const linkTarget = link ? target : null;
  const card = React.createElement(
    link ? "a" : "button",
    {
      href: link,
      className: classnames("uikit__nav-card__card", className),
      disabled,
      onClick,
      target: linkTarget,
      ...createDataAttributes(dataAttrib)
    },
    <>
      <span className="uikit__icon-wrapper">
        {React.isValidElement(icon) ? (
          <span className="uikit__nav-card__icon">{icon}</span>
        ) : (
          <Icon className="uikit__nav-card__icon" icon={icon} />
        )}
      </span>
      <span className="uikit__nav-card__title">{title}</span>
    </>
  );
  return card;
};

NavCard.propTypes = {
  onClick: propTypes.func,
  icon: propTypes.oneOfType([propTypes.string, propTypes.element]).isRequired,
  title: propTypes.string.isRequired,
  disabled: propTypes.bool,
  link: propTypes.string,
  target: propTypes.string,
  dataAttrib: propTypes.arrayOf(Object)
};

NavCard.defaultProps = {
  disabled: false,
  target: "_self"
};

export default NavCard;
